import React, { useContext } from 'react'

import Box from '../Box'
import DropdownContext from './DropdownContext'
import { BoxProps } from '../Box/Box.types'

const DropdownToggle: React.FC<BoxProps> = ({ children }) => {
  const { onToggle, trigger, onShow } = useContext(DropdownContext)

  const eventTrigger: Record<string, unknown> = {}

  switch (trigger) {
    case 'click':
      eventTrigger.onClick = onToggle
      break
    case 'hover':
      eventTrigger.onMouseEnter = onShow
      break
    default:
      eventTrigger.onClick = onToggle
      break
  }

  return (
    <Box as='span' {...eventTrigger} aria-label='toggle'>
      {children}
    </Box>
  )
}

export default DropdownToggle
